import React from 'react';

interface Props {
	heading?: string;
	children: React.ReactNode;
}
const PreferenceWrapper = ({ children, heading }: Props) => {
	return (
		<div>
			{heading ? <p className="text-[15px] font-[500] dark:text-[#C7C9D9] mb-[16px]">{heading}</p> : null}
			{children}
		</div>
	);
};

export default PreferenceWrapper;
